import React from 'react';
import connectWithCore from 'framework/hocs/connectWithCore';
import {ScoringForm} from 'app-ui-componentlibrary/dist/componentLibrary/form/ScoringForm';

export {ScoringForm};
export default connectWithCore(ScoringForm);
